// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"4bb958cf","465":"fdbd01ef","487":"7a07d260","607":"2f39ec96","641":"77bb5cb4","756":"c02290c4"}[chunkId] + ".chunk.js";
};